module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/historia-fc91b8b1.png";